import { API_ROUTES } from "../config/baseURL";
import request from "./clientsApi";

const empresaApi = {
    getAll: () =>
        request(API_ROUTES.empresas).then((r) => r.json()),

    getAllActivas: () =>
        request(`${API_ROUTES.empresas}?estado=1`).then((r) => r.json()),

    save: (data) =>
        request(API_ROUTES.empresa, {
            method: data.id ? "PUT" : "POST",
            body: JSON.stringify(data),
        }).then((r) => r.json()),
};

export default empresaApi;
